<div class="jumbotron animated fadeIn fast">
  <h2 class="title">Carga de Solicitud</h2>
  <app-alert *ngIf="error" [alert]="error"></app-alert>
  <div class="container-fluid">
    <form [formGroup]="form">
      <div>
        <div class="col-md-4">
          <div
            class="form-group"
            [class.has-error]="helpers.invalidControl(form.get('type'))"
          >
            <label class="label-form" for="type">Tipo de Solicitud</label>
            <select class="form-control" formControlName="type">
              <option value="" disabled selected>Seleccione</option>
              <option
                *ngFor="let type of requestTypes"
                value="{{ type.value }}"
              >
                {{ type.name }}
              </option>
            </select>
            <i
              class="glyphicon glyphicon-menu-down form-control-feedback custom-select-arrow"
            ></i>
            <span
              class="help-block invalid-feedback"
              *ngIf="helpers.invalidControl(form.get('type'))"
            >
              <span *ngIf="form.get('type').errors.required">{{
                constants.validations.required.message
              }}</span>
            </span>
          </div>
        </div>
        <div class="col-md-8 text-right downloads" *ngIf="form.valid">
          <a [href]="getFilePath().path" [download]="getFilePath().name"><b class="primary download"
            ><img
              src="assets/images/requests/download.png"
              alt="Descargar planilla"
            />
            Descargar macro para generar archivo a cargar
          </b></a>
        </div>
      </div>
      <app-loading *ngIf="loading"></app-loading>
      <div *ngIf="!loading" class="drop-content">
        <div
          class="well-lg drop-zone"
          appDragAndDrop
          (file)="onFileSelected($event)"
          (isOver)="isOver = $event"
          #fileInput
          (click)="fileInput.value = null"
          [ngClass]="{ 'file-over': isOver }"
        >
          <img [src]="icon" alt="Subir planilla" />
          <h4 class="secondary">{{ title }}</h4>
          <input
            type="file"
            name="file"
            id="upload-file"
            #fileInput
            (click)="fileInput.value = null"
            (change)="onFileSelected($event.target.files[0])"
          />
          <span class="secondary">
            Arrastra el documento o
            <label for="upload-file" class="secondary search"
              >Busca en tu ordenador</label
            >
          </span>
        </div>
      </div>
      <span class="secondary">
        *Recuerda que solo puedes adjuntar un solo documento y su peso máximo no
        debe superar los 3 mb.
      </span>
      <span class="secondary mt-10">
        *Recuerda que debes usar una nomenclatura ya definida para el nombre del
        archivo txt que se cargará.
        <b class="primary pointer" (click)="showModal()" *ngIf="form.valid">Ejemplo {{ getTypeName() }}</b>
      </span>
      <div class="row">
        <div
          class="alert alert-success center-block text-left animated fadeIn fast"
          *ngIf="file"
        >
          <span>{{ file.name }}</span>
          <img
            class="file-success-icon"
            src="assets/images/requests/icn-check.png"
            alt="OK"
          />
        </div>
      </div>
      <div class="row">
        <button
          class="button form-control"
          [disabled]="!canContinue() || loading"
          (click)="continue()"
        >
          Continuar
        </button>
      </div>
    </form>
  </div>
</div>
